import Slider from '../src/slider';
import 'jquery';
import 'gsap';
import 'ScrollMagic';
import 'ScrollMagic.animation.gsap';
import 'ScrollMagic.debug.addIndicators';
import 'cycle2';
import 'cycle2-center';
import 'cycle2-swipe';


export default function page_general(app) {

}


/** WEBPACK FOOTER **
 ** ./assets/scripts/views/page_general.js
 **/